<template>
    <div :class="['custom-textarea', cssClass, disabled ? 'input-disabled' : '']">
        <label v-if="showLabel && $te(label)" :for="uniqueId" :class="['input-label', { required: required }]">{{ $t(label) }}</label>
        <textarea
            :value="modelValue"
            :id="uniqueId"
            :ref="inputKey"
            :name="inputKey"
            :placeholder="$t(placeholder)"
            :disabled="disabled"
            :required="required"
            @input="onInput"
            :minlength="min"
            :maxlength="max"
        ></textarea>

        <p v-if="!inputError && $te(description)" class="input-description">{{ $t(description) }}</p>
        <p v-if="inputError" class="input-error">{{ $te(error) ? $t(error) : $t('fields.default.input.error') }}</p>
    </div>
</template>

<script>
import { nextTick } from 'vue';

export default {
    props: {
        inputKey: String,
        modelValue: String,
        required: {
            type: Boolean,
            default: false,
        },
        showLabel: {
            type: Boolean,
            default: true,
        },
        cssClass: {
            type: String,
            default: '',
            required: false
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        min: [String, Number],
        max: [String, Number]
    },
    data() {
        return {
            inputError: false,
            placeholder: `fields.${this.inputKey}.placeholder`,
            label: `fields.${this.inputKey}.label`,
            error: `fields.${this.inputKey}.error`,
            description: `fields.${this.inputKey}.description`,
            uniqueId: `${this.inputKey}-${Math.random().toString(36).substr(2, 9)}`
        };
    },
    methods: {
        onInput(event) {
            this.$emit('update:modelValue', event.target.value);
            nextTick(() => {
                this.validateInput(event.target);
            });
        },
        validateInput(input) {
            if (!input.checkValidity()) {
                this.inputError = true;
                input.classList.add('is-invalid');
                input.classList.remove('is-valid');
                return false;
            } else {
                this.inputError = false;
                input.classList.remove('is-invalid');
                input.classList.add('is-valid');
                return true;
            }
        },
        triggerValidation() {
            const input = this.$refs[this.inputKey];
            if (input) {
                return this.validateInput(input);
            } else {
                // Nothing to see here.
                return true;
            }
        }
    },
};

</script>